"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTrendDirection = exports.getTrendDisplayFromRatio = exports.getIcon = exports.isIncreasingOrInfinity = exports.shouldShowTrends = exports.isLargeChange = exports.formatPercentage = void 0;
var react_1 = __importDefault(require("react"));
var icons_1 = require("../icons");
var formatPercentage = function (v) {
    if (v === Number.POSITIVE_INFINITY || v === Number.NEGATIVE_INFINITY) {
        return null;
    }
    return "".concat(Math.round(v * 100), "%");
};
exports.formatPercentage = formatPercentage;
var isNullOrUndefined = function (trendValue) {
    return trendValue === null ||
        typeof trendValue === 'undefined' ||
        Number.isNaN(trendValue);
};
var isUnchanged = function (trendValue) { return trendValue === 1; };
var isInfinity = function (trendValue) { return trendValue === -1; };
var isIncreasing = function (trendValue) { return trendValue > 1; };
var isLargeIncrease = function (trendValue) { return trendValue >= 10; };
// insignificant: being within .001 away from 1; these render as 0%
var isInsignificantChange = function (trendValue) {
    return trendValue && Math.abs(trendValue - 1) < 0.01;
};
// Remember not to give this special treatment when trendValue is 0, because
// this can simply be displayed as "-100%". Note that `isLargeDecrease` is false
// for the largest possible decrease.
var isLargeDecrease = function (trendValue) {
    return trendValue <= 0.001 && trendValue !== 0;
};
var isLargeChange = function (trendValue) {
    return isLargeIncrease(trendValue) || isLargeDecrease(trendValue);
};
exports.isLargeChange = isLargeChange;
var shouldShowTrends = function (trendValue) {
    return !(isNullOrUndefined(trendValue) || isUnchanged(trendValue)) &&
        !isInsignificantChange(trendValue);
};
exports.shouldShowTrends = shouldShowTrends;
var isIncreasingOrInfinity = function (trendValue) {
    return isIncreasing(trendValue) || isInfinity(trendValue);
};
exports.isIncreasingOrInfinity = isIncreasingOrInfinity;
var getIcon = function (trendValue, color) {
    var upArrow = react_1.default.createElement(icons_1.ArrowTrendUpIcon, { viewBox: '4 4 16 16', color: color });
    var downArrow = react_1.default.createElement(icons_1.ArrowTrendDownIcon, { viewBox: '4 4 16 16', color: color });
    return isIncreasing(trendValue) ? upArrow : downArrow;
};
exports.getIcon = getIcon;
// Note: this function formats for 2 digits BEFORE the decimal and adds an x.
// The extra toPrecision call is not redundant.
var twoSignificantDigitsWithX = function (num) {
    return "".concat(Number(num.toPrecision(2)).toPrecision().toLocaleString(), "x");
};
var formatLargeChange = function (trendValue) {
    trendValue = isLargeDecrease(trendValue) ? 1 / trendValue : trendValue;
    return twoSignificantDigitsWithX(trendValue);
};
var getTrendDisplayFromRatio = function (trend) {
    if (isInfinity(trend)) {
        return null;
    }
    return (0, exports.isLargeChange)(trend)
        ? formatLargeChange(trend)
        : (0, exports.formatPercentage)(Math.abs(trend - 1));
};
exports.getTrendDisplayFromRatio = getTrendDisplayFromRatio;
var getTrendDirection = function (trendValue) {
    var isInvalidTrend = isUnchanged(trendValue) ||
        isNullOrUndefined(trendValue) ||
        isInfinity(trendValue);
    if (isIncreasing(trendValue)) {
        return 'higher';
    }
    if (isInvalidTrend) {
        return 'unchanged';
    }
    return 'lower';
};
exports.getTrendDirection = getTrendDirection;
//# sourceMappingURL=utils.js.map